import { Skeleton } from '@mui/material';
import {
    ArrowRightIcon,
    CalendarIcon,
    EditIcon,
    LocationIcon,
    ProfileIcon,
} from 'app/agriculture/icons';
import { SkeletonButton } from 'app/agriculture/components/Button/SkeletonButton';
import { NoteRowHeaderItemSkeleton } from './NoteRowHeaderItemSkeleton';
import './NoteRow.scss';

export function NoteRowSkeleton() {
    return (
        <div className="NoteRow" data-testid="NoteRowSkeleton">
            <Skeleton variant="text" width={140} />
            <div className="NoteRow__header">
                <NoteRowHeaderItemSkeleton
                    className="NoteRow__name"
                    icon={<ProfileIcon color="#ccc" />}
                    width={120}
                />
                <NoteRowHeaderItemSkeleton
                    className="NoteRow__timestamp"
                    icon={<CalendarIcon color="#ccc" />}
                    width={120}
                />
                <NoteRowHeaderItemSkeleton
                    className="NoteRow__location"
                    icon={<LocationIcon color="#ccc" />}
                    width={60}
                />
                <SkeletonButton
                    variant="compact"
                    startIcon={<EditIcon color="#ccc" />}
                    width={24}
                />
            </div>
            <Skeleton height={60} />
            <SkeletonButton
                variant="compact"
                endIcon={<ArrowRightIcon color="#ccc" />}
                width={95}
            />
        </div>
    );
}
